import React, { FC } from 'react'
import CommonGrid from '@components/blocks/CommonGrid'
import { RowProps, CommonGridProps } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'
import { filterSortRowsBySettings, sliceDataBySettings } from './utils'
import { x } from '@xstyled/styled-components'
import { rowHeight, gridLayoutHeight } from './constants'

type Props = {
  items?: RowProps[]
  height?: string
  autoHeightByRows?: boolean
} & Omit<CommonGridProps, 'rowsData' | 'totalRowsCount'>

export const FormGrid: FC<Props> = ({ items = [], autoHeightByRows = false, isLoading, ...rest }) => {
  const { gridSelectors } = rest
  const filteredItems = React.useMemo(() => filterSortRowsBySettings(items, gridSelectors), [items, gridSelectors])
  const filteredItemsCount = filteredItems.length
  const pageItems = React.useMemo(() => sliceDataBySettings(filteredItems, gridSelectors), [filteredItems, gridSelectors])

  React.useEffect(() => {
    rest.gridActions?.clearSettings?.()
  }, []) // clear grid redux form previous expedition

  const rowsPerPage = rest.gridSelectors.rowsPerPage || 10
  const h = autoHeightByRows ? `${Math.min(rowsPerPage, filteredItemsCount) * rowHeight + gridLayoutHeight}px` : '610px'

  return (
    <x.div h={h}>
      <CommonGrid
        isLoading={isLoading !== undefined ? isLoading : false}
        rowsData={pageItems}
        totalRowsCount={filteredItemsCount}
        {...rest}
      />
    </x.div>
  )
}
